<div>
  <app-titlebar #titlebar (onReady)="doComReady($event,'titlebar')">
  </app-titlebar>
</div>
<div >
  <div class="w-full">
    <mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
      <mat-tab #myTabGrid label="條件設定">
        <mat-toolbar class="h-9">
          <button class="btn-primary" (click)="doQuery2()">
            <mat-icon fontIcon="search"></mat-icon>查詢
          </button>
          <button class="btn-info" (click)="doGetPreFilter()">
            <mat-icon fontIcon="search"></mat-icon>取前次
          </button>
          <button mat-icon-button matTooltip="TURNKEY資料查詢(TAXPQ80) 開新視窗"
            (click)="openHelpWindow('https://docs.google.com/document/d/1RNVZ1QKPSoEadamX0g4IzVWK01ygJdVXks6T67Rp9y4/edit?tab=t.0#heading=h.pa66oa8tdn6f')">
            <mat-icon>help_outline</mat-icon>
          </button>
        </mat-toolbar>
        <div class="flex">
          <div class="jk-row-border" style="width: 360px;">
            <div>
              <app-jkcombobox [label]="'訊息類型'" (onReady)="doComReady($event,'kind')" comName="kind" [(value)]="kind"
                [items]="kindList" [disabled]="true">
              </app-jkcombobox>

            </div>
            <div>
              <app-jkdaterange #rgWC004Com (onReady)="doComReady($event,'rgWC004')" comName="rgWC004" [label]="'開立日期'"
                [(valueA)]="filterOpt.date1" [(valueB)]="filterOpt.date2" [showClearButton]="true">
              </app-jkdaterange>
              <app-jkcheckbox label="TURNKEY狀態 不是確認的" #notConfirmCom comName="notConfirm"
                (onReady)="doComReady($event,'notConfirm')" [(value)]="filterOpt.notConfirm">
              </app-jkcheckbox>
              <app-jkrange comName="rgWC001" (onReady)="doComReady($event,'rgWC001')" #rgWC001Com class="jk-range"
                label="發票號碼" maintable="TAXWC" item="W01" [valueA]="filterOpt.taxno1" [showOpenWinButton]="false"
                [valueB]="filterOpt.taxno2">
              </app-jkrange>
              <app-jkmultiselect #msStatusCom comName="msStatus" (onReady)="doComReady($event,'msStatus')"
                maintable="JCKMG" item="W01" label="TURNKEY狀態" valueExpr="MG002" displayExpr="MG003"
                [(values)]="filterOpt.status" [params]="['TAXWC084']">
              </app-jkmultiselect>
              <app-jkmultiselect #msWC001Com comName="msWC001" (onReady)="doComReady($event,'msWC001')" maintable="TAXWC"
                item="W01" label="發票號碼" valueExpr="發票號碼" displayExpr="訊息類別" [(values)]="filterOpt.msWC001">
              </app-jkmultiselect>
            </div>
          </div>
          <div class="jk-row-border" style="width: 360px;">
            <app-jkrange #rgWC003Com comName="rgWC003" (onReady)="doComReady($event,'rgWC003')" class="jk-range"
            label="申報年月" maintable="" item="" [valueA]="filterOpt.month1" [width]="300" [showOpenWinButton]="false"
            [valueB]="filterOpt.month2">
          </app-jkrange>
          <app-jkmultiselect #msWC006Com comName="msWC006" (onReady)="doComReady($event,'msWC006')" maintable="TAXMA"
              item="W03" label="賣方/送方統編" valueExpr="MA003" displayExpr="MA002" [(values)]="filterOpt.msWC006">
            </app-jkmultiselect>
            <app-jkmultiselect #msWC005Com comName="msWC005" (onReady)="doComReady($event,'msWC005')" maintable="TAXWC"
              item="W05" label="買方/收方統編" valueExpr="WC005" displayExpr="WC005" [(values)]="filterOpt.msWC005">
            </app-jkmultiselect>
            <app-jkdaterange #rgCreateDateCom label="建檔日期" comName="rgCreateDate"
              (onReady)="doComReady($event,'rgCreateDate')" [(valueA)]="filterOpt.createDate1"
              [(valueB)]="filterOpt.createDate2" [showClearButton]="true">
            </app-jkdaterange>
          </div>

        </div>
      </mat-tab>
      <mat-tab #myTabDetail label="詳細資料">
        <app-jkgridwin (afterGridReady)="afterGridReady($event)" (rowClicked)="agRowClicked($event)">
        </app-jkgridwin>
      </mat-tab>
    </mat-tab-group>
  </div>

</div>
